import "./App.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import { Route, Routes } from "react-router-dom";

import Navbar from "./components/Navbar";
import AboutMePage from "./components/AboutMePage";
import FactoryAutomationPage from "./components/FactoryAutomationPage";
import FullstackPage from "./components/FullstackPage";
import CloudComputingPage from "./components/CloudComputingPage";
import CVPage from "./components/CVPage";
import ChatbotIcon from "./components/ChatBotIcon";

import "./App.css";
function App() {
  return (
    <div className="body">
      <div>
        <Navbar />
      </div>
      <Routes>
        <Route path="/" element={<AboutMePage />} />
        <Route path="/factory-automation" element={<FactoryAutomationPage />} />
        <Route path="/fullstack" element={<FullstackPage />} />
        <Route path="/cloud-computing" element={<CloudComputingPage />} />
        <Route path="/cv" element={<CVPage />} />
      </Routes>
      <ChatbotIcon />
    </div>
  );
}

export default App;
